<template>
  <div class="home">
    <Hero />
    <Lead />
    <Services />
    <Clients
      header="Our work is being touched by millions of users. Throughout the years we've had the pleasure of working with some of the most amazing brands and people."
    />
    <StartProject />
    <!--<Case header="Breaching the Great Firewall of China"/>-->
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/home/Hero.vue";
import Lead from "@/components/home/Lead.vue";
import Services from "@/components/home/Services.vue";
import Clients from "@/components/home/Clients.vue";
import StartProject from "@/components/home/StartProject.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "home",
  components: {
    Hero,
    Lead,
    Services,
    Clients,
    StartProject,
    Footer
  },
  beforeCreate: function() {
    document.body.classList.remove("dark");
    document.body.classList.remove("invert");
  },
  methods: {
    invertColor() {
      if (window.scrollY > window.innerHeight)
        document.body.classList.add("invert");
      else document.body.classList.remove("invert");
    }
  },
  created() {
    window.addEventListener("scroll", this.invertColor);
  },
  destroyed() {
    window.removeEventListener("scroll", this.invertColor);
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.images {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  img {
    max-width: 100%;
  }
}
</style>
